
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#939393","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26 16c0 2.191-1.77 4-4 4s-4-1.808-4-4 1.77-4 4-4 4 1.809 4 4zm-2 0c0-1.12-.917-2-2-2-1.084 0-2 .878-2 2 0 1.121.916 2 2 2 1.083 0 2-.88 2-2zm11 6c0-1.12-.917-2-2-2-1.084 0-2 .879-2 2 0 1.122.916 2 2 2 1.083 0 2-.88 2-2zm2 0c0 2.191-1.77 4-4 4s-4-1.808-4-4 1.77-4 4-4 4 1.809 4 4zm-22 4c0 2.191-1.77 4-4 4s-4-1.808-4-4 1.77-4 4-4 4 1.809 4 4zm-2 0c0-1.12-.917-2-2-2-1.084 0-2 .878-2 2 0 1.121.916 2 2 2 1.083 0 2-.88 2-2zm8-13.047V7.047c0-1.396 2-1.396 2 0v5.906c0 1.396-2 1.396-2 0zM10 23.11V6.89c0-1.185 2-1.185 2 0v16.22c0 1.185-2 1.185-2 0zm22-4.088V6.977c0-1.303 2-1.303 2 0v12.046c0 1.303-2 1.303-2 0zm0 18.12v-8.286c0-1.143 2-1.143 2 0v8.286c0 1.143-2 1.143-2 0zm-11 .984V23.873c0-1.164 2-1.164 2 0v14.254c0 1.164-2 1.164-2 0zm-11-1.062v-4.13c0-1.247 2-1.247 2 0v4.13c0 1.247-2 1.247-2 0z"}})])
          )
        }
      }
    